import { render } from "./CityPoints.vue?vue&type=template&id=06da459c&scoped=true"
import script from "./CityPoints.vue?vue&type=script&lang=js"
export * from "./CityPoints.vue?vue&type=script&lang=js"

import "./CityPoints.vue?vue&type=style&index=0&id=06da459c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06da459c"]])

export default __exports__